import { render, staticRenderFns } from "./SmsGuidance.vue?vue&type=template&id=e094cf44&scoped=true"
import script from "./SmsGuidance.vue?vue&type=script&lang=js"
export * from "./SmsGuidance.vue?vue&type=script&lang=js"
import style0 from "./SmsGuidance.vue?vue&type=style&index=0&id=e094cf44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e094cf44",
  null
  
)

export default component.exports